;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/sign-in/:sign-in*?\",\"regex\":\"^/sign-in(?:/(.*))?$\",\"paramNames\":[\"sign-in\"],\"hasOptionalPrefix\":false},{\"path\":\"/sign-up/:sign-up*?\",\"regex\":\"^/sign-up(?:/(.*))?$\",\"paramNames\":[\"sign-up\"],\"hasOptionalPrefix\":false},{\"path\":\"/proofing/:transferId\",\"regex\":\"^/proofing/([^/]+)$\",\"paramNames\":[\"transferId\"],\"hasOptionalPrefix\":false},{\"path\":\"/d/:token\",\"regex\":\"^/d/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/proof/:token\",\"regex\":\"^/proof/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false},{\"path\":\"/r/:token\",\"regex\":\"^/r/([^/]+)$\",\"paramNames\":[\"token\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/admin/beta/feedback\"},{\"path\":\"/admin/stats\"},{\"path\":\"/admin/users\"},{\"path\":\"/accept-invite\"},{\"path\":\"/proofing\"},{\"path\":\"/proofing/new\"},{\"path\":\"/requests\"},{\"path\":\"/send\"},{\"path\":\"/settings\"},{\"path\":\"/settings/branding\"},{\"path\":\"/settings/contacts\"},{\"path\":\"/transfers\"},{\"path\":\"/\"},{\"path\":\"/acceptable-use\"},{\"path\":\"/beta\"},{\"path\":\"/dmca\"},{\"path\":\"/download\"},{\"path\":\"/privacy\"},{\"path\":\"/terms\"},{\"path\":\"/dev/copy-audit\"},{\"path\":\"/dev/design-system\"},{\"path\":\"/dev/domain-delete-modal\"},{\"path\":\"/dev/email-preview\"},{\"path\":\"/sso-callback\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.4";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs'
import { isExclusivelyThirdPartyEvent } from '@/lib/sentry-filter'

const env = process.env.NEXT_PUBLIC_VERCEL_ENV ?? process.env.NODE_ENV ?? 'development'
const isProd = env === 'production'

Sentry.init({
  dsn: 'https://ee40932c1b6a00da821807fc557dc05d@o4511384028446720.ingest.us.sentry.io/4511384028643328',
  environment: env,
  release: process.env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,

  integrations: [Sentry.replayIntegration({ maskAllText: false, blockAllMedia: true })],

  tracesSampleRate: isProd ? 0.1 : 1.0,
  enableLogs: true,

  replaysSessionSampleRate: isProd ? 0.05 : 0.1,
  replaysOnErrorSampleRate: 1.0,

  sendDefaultPii: true,
  enabled: env !== 'development',

  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'ResizeObserver loop completed with undelivered notifications',
    'Non-Error promise rejection captured',
    'Network request failed',
    'Failed to fetch',
    'Load failed',
    'AbortError',
    'cancelled',
    // Next.js RSC Flight stream aborted mid-read (navigation, tab close, or the
    // /d/:token download setting window.location.href) — reported as an unhandled
    // rejection from react-server-dom-*-client, no app code at fault (SNAPTRANSFER-WEB-T).
    'Connection closed.',
    /^Loading chunk \d+ failed/,
    /^Loading CSS chunk \d+ failed/
  ],

  denyUrls: [/^chrome-extension:\/\//, /^moz-extension:\/\//, /^safari-extension:\/\//],

  // denyUrls only catches extension errors that carry an extension URL. Injected
  // scripts often surface as `<anonymous>` frames with no URL (e.g. an
  // auto-clicker probing for an input that isn't there — SNAPTRANSFER-WEB-S), so
  // also drop any event whose frames are exclusively non-first-party.
  beforeSend(event) {
    if (isExclusivelyThirdPartyEvent(event)) return null
    return event
  }
})

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart
